<template lang="pug">
.v-map-aside-card.map-aside-card(
		v-if="data"
		:class="{'active': activeId === data.id}"
		@click="setActiveMarker(data.id)")
	.map-aside-card__background
	.map-aside-card__wrap
		.map-aside-card__title(v-if="data.title" ) {{ data.title }}
		.map-aside-card__items.flc(v-if="data.items" )
			.map-aside-card__item(v-for="(info, index) in data.items" :key="index")
				.map-aside-card__item-title(v-if="info.title" ) {{ info.title }}
				template(v-if="info.items" )
					.map-aside-card__item-info(v-for="(item, index) in info.items" :key="index" )
						a.map-aside-card__item-link(
								v-if="item && item.href"
								:href="item.href")
							|{{ item.text }}
						.map-aside-card__item-link( v-else-if="item" v-html="item.text" )
		a.map-aside-card__link.btn--card(v-if="data.link" @click.stop :href="data.link?.href") {{ data.link?.text }}


</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {

	mixins: [
		sourceMixin
	],

	emits: [
		'active-marker'
	],

	props: {
		activeId: {
			type: [String, Number],
			default: null
		}
	},

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},

		setActiveMarker(id) {
			this.$emit('active-marker', id)
		}
	}
}

</script>